import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { ImageBackground, StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

type WrapperProps = BoxProps & {
  $fullHeight?: boolean;
  $constrainToViewHeight?: boolean;
  $windowHeight?: number;
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: primitive.$mayoEggWhite,
  },
  fullHeight: {
    height: '100%',
  },
});

export const Wrapper = ({
  $fullHeight,
  $constrainToViewHeight,
  $windowHeight,
  style,
  ...props
}: WrapperProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.wrapper,
      $fullHeight && styles.fullHeight,
      $constrainToViewHeight && $windowHeight ? { maxHeight: $windowHeight } : undefined,
      style,
    ],
  });

export const StyledImageBackground = makeUclComponent(ImageBackground).withConfig({
  height: '100%',
  width: '100%',
  flex: 1,
});
